export default "__VITE_ASSET__BGmD_J7r__"